module.exports = __webpack_public_path__ + "static/media/front.a591d190.jpg";